import { Component, forwardRef, Input, QueryList, ViewChildren } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { QsaRow } from '../models/bureau-cnpj-information.model';
import { QsaTreeHost } from '../models/qsa-tree-host.model';

@Component({
  selector: 'app-qsa-node',
  templateUrl: './qsa-node.component.html',
  styleUrls: ['./qsa-node.component.scss'],
  standalone: false,
})
export class QsaNodeComponent {
  @Input()
  public nodes: QsaRow[] = [];

  @Input()
  public host: QsaTreeHost;

  @ViewChildren(MatExpansionPanel)
  private panels: QueryList<MatExpansionPanel>;

  @ViewChildren(forwardRef(() => QsaNodeComponent))
  private childLevels: QueryList<QsaNodeComponent>;

  // Campos invalidos podem estar em niveis fechados da arvore.
  public openAll(): void {
    this.panels?.forEach((panel) => panel.open());
    this.childLevels?.forEach((level) => level.openAll());
  }

  public trackByDocument(_index: number, node: QsaRow): string {
    return node.document;
  }
}
